// src/components/StampItem.js
import { useTranslation } from 'react-i18next';

export default function StampItem({ stamp, onClick }) {
  const { t } = useTranslation();
  const isDone = !!stamp?.completed;
  const category = stamp?.category;

  // バッジ画像の出し分け
  const STAMP_BASE = '/images/stamp/stampspot-icon.svg';
  const STAMP_DONE = '/images/stamp/stampget-icon.svg';
  const QUIZ_BASE  = '/images/stamp/quiz-icon.svg';
  const QUIZ_DONE  = '/images/stamp/quizget-icon.svg';

  const badgeSrc =
    category === 'Stamp'
      ? (isDone ? STAMP_DONE : STAMP_BASE)
      : (isDone ? QUIZ_DONE : QUIZ_BASE); // Select_Quiz / Input_Quiz はQUIZ扱い

  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        all: 'unset',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 10,
      }}
      aria-label={stamp?.name || t('stampList.unknown', 'エリア名')}
    >
      {/* 四角いカード */}
      <div
        style={{
          width: '100%',
          aspectRatio: '1 / 1',
          border: '2px solid #d1d5db',
          borderRadius: 18,
          display: 'grid',
          placeItems: 'center',
          background: '#fff',
          boxShadow: '0 1px 0 rgba(0,0,0,0.02)',
        }}
      >
        <img
          src={badgeSrc}
          alt=""
          style={{
            width: 120,
            height: 120,
            display: 'block',
            ...(isDone ? {} : { filter: 'grayscale(100%) opacity(0.5)' }),
          }}
          onError={(e) => {
            // フォールバック（カテゴリに応じてベースに戻す）
            e.currentTarget.src = category === 'Stamp' ? STAMP_BASE : QUIZ_BASE;
            if (!isDone) {
              e.currentTarget.style.filter = 'grayscale(100%) opacity(0.5)';
            }
          }}
        />
      </div>

      {/* ラベル */}
      <div
        style={{
          fontSize: 14,
          fontWeight: 700,
          color: '#111827',
          textAlign: 'center',
          lineHeight: 1.4,
          wordBreak: 'keep-all',
        }}
      >
        {stamp?.name || t('stampList.unknown', 'エリア名')}
      </div>
    </button>
  );
}
